module.exports = __webpack_public_path__ + "static/media/avatar6.9e424ea3.jpg";